import * as winston from 'winston';
// import winstonDailyRotateFile from 'winston-daily-rotate-file';

const logFormat = winston.format.combine(
  winston.format.colorize(),
  winston.format.timestamp(),
  winston.format.align(),
  winston.format.printf(
    info => `${info.timestamp} ${info.level} ${info.message}`
  )
);

const logger = winston.createLogger({
  format: logFormat,
  transports: [
    // new winstonDailyRotateFile({
    //   filename: './logs/drug-exceptions=%DATE%.log',
    //   datePattern: 'YYYY-MM-DD',
    //   level: 'info',
    // }),
    new winston.transports.Console({
      level: 'info',
    }),
  ],
});

export default logger;
